import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegacyTaskTableComponent } from './table.component';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { ProjectDialogPanelsModule } from 'app/modules/projects/project-dialog/panels/panels.module';
import { SharedModule } from 'app/shared/shared.module';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatTableModule,
    DragDropModule,
    MatIconModule,
    ProjectDialogPanelsModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatButtonModule,
    RouterModule,
  ],
  declarations: [LegacyTaskTableComponent],
  exports: [LegacyTaskTableComponent],
})
export class LegacyTaskTableModule {}
